export const SMS_CHANNEL_UID = 'i2aaq98fgh9kjuvh';
export const EMAIL_CHANNEL_UID = 'dujrmr24hpmerwkr';
